const eventListeners = new Map();

export const dispatch = (action, data) => {
  parent.postMessage(
    { pluginMessage: { action, data }, pluginId: import.meta.env.VITE_PLUGIN_ID },
    'https://www.figma.com'
  );
};

export const handleEvent = (type, handler) => {
  const handlers = eventListeners.get(type) || new Set();
  handlers.add(handler);
  eventListeners.set(type, handlers);
};

export const removeEvent = (type, handler) => {
  if (!handler) return eventListeners.delete(type);

  const handlers = eventListeners.get(type);

  if (!handlers) return;

  handlers.delete(handler);

  if (handlers.size === 0) {
    eventListeners.delete(type);
  }
};

export const resolveEvent = (type) => {
  return new Promise((resolve) => {
    const handler = (data) => {
      removeEvent(type, handler);
      resolve(data);
    };

    handleEvent(type, handler);
  });
};

window.addEventListener('message', (event) => {
  const message = event.data.pluginMessage?.pluginMessage;

  if (!message) return;

  const handlers = eventListeners.get(message.action);

  handlers?.forEach((handler) => handler(message.data));
});
